import { pipe, replace } from "ramda";

export const capitalize: (t: string) => string = pipe(
  (text) => text.toLowerCase(),
  replace(/\W?\b[a-z]/gm, (m) => m[0].toUpperCase())
);

export const splitSnakeCase = replace(/_+/gm, " ");
